<template>
  <div class="bg-white p-4 border rounded shadow-sm">
    <div class="font-semibold mx-2 text-gray-600">{{title}}</div>
    <div class="flex my-3 justify-between">
      <div class="w-full mr-2">
        <label class="block text-sm ">Hotspot name<span class="text-red-700">*</span></label>
        <input aria-label="hotspot name" type="text" required v-model="name" class="appearance-none rounded-md relative block w-full px-3 py-2 border
                                       border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none
                                       focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="Hotspot name"/>
      </div>
      <div class="w-full ml-2">
        <label class="block text-sm leading-5 ">Make</label>
        <select class="block  w-full py-2 px-4 pr-8  rounded border
                                       border-gray-300 bg-white focus:outline-none focus:bg-white"
                @change="setMake($event)" v-model="make" placeholder="make">
          <option value="">Select Make</option>
          <option value="Meraki">Meraki</option>
          <option value="Mikrotik">Mikrotik</option>
          <option value="Cisco Controller">Cisco Controller</option>
          <option value="Rukus">Rukus</option>
          <option value="Brandfi">Brandfi</option>
        </select>
      </div>
    </div>
    <div class="flex my-3 justify-between">
      <div class="w-full mr-2">
        <label class="block text-sm leading-5 ">Mac address</label>
        <input aria-label="Password" name="mac_address" type="text" v-model="mac_address" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="XX:XX:XX:XX:XX:XX"/>
      </div>
      <div class="w-full ml-2">
        <label class="block text-sm leading-5 ">Serial number</label>
        <input name="serial_number" type="text" v-model="serial_number" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="Serial number"/>
      </div>
    </div>
    <div class="flex my-3 justify-between">
      <div class="w-full mr-2">
        <label class="block text-sm leading-5 ">Success URL</label>
        <input name="success_url" type="text" required v-model="custom_success_url" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="https://"/>
      </div>
      <div class="w-full ml-2">
        <label class="block text-sm leading-5 ">Custom Splash URL</label>
        <input  name="custom_splash_url" type="text" required v-model="custom_splash_url" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="https://"/>
      </div>
    </div>
    <div class="my-3">
      <label class="block text-sm leading-5 ">Description</label>
      <textarea v-model="description" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                placeholder="Describe..."></textarea>
    </div>
    <div class="mt-6">
      <div class="flex justify-between">
        <button  v-if="$store.getters.can(accessPointId == null ?'create_ap':'edit_ap')" v-on:click="updateOrCreateHotspot" class="rounded float-right px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white">
          {{ accessPointId == null ? "Create" : "Update" }} access point
        </button>
        <button type="submit" v-on:click="goBack()" class="bg-transparent rounded float-left px-4 md:px-5 xl:px-4 border border-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-teal-500">
          Back
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "../services/Utils";

export default {
  name: "UpdateOrCreateAccessPointComponent",
  props: {
    accessPointId: String,
    venueId: String,
    title: {type: String, default: "Create a new access point"}
  },
  data() {
    return {
      hotspot: null,
      make: null,
      name: null,
      mac_address: null,
      serial_number: null,
      custom_splash_url: null,
      custom_success_url: null,
      description: null,
      loading: false,
      errors: []
    }
  },
  mounted() {
    if (this.accessPointId != null)
      this.getHotspot()
  },
  watch: {
    hotspot: function (hotspot) {
      this.name = hotspot.name;
      this.make = hotspot.make;
      this.mac_address = hotspot.mac_address;
      this.serial_number = hotspot.serial_number;
      this.custom_splash_url = hotspot.custom_splash_url;
      this.custom_success_url = hotspot.custom_success_url;
      this.description = hotspot.description;
    },
    errors: function (errors) {
      this.$root.$emit('alert_error', errors);
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    setMake: function (event) {
      let make = event.target.value;
      this.make = make;
    },
    getHotspot() {
      this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/access_points/' + this.accessPointId)
          .then((result) => {
            this.hotspot = result.data.data.access_point;
          })
          .catch(() => {
            this.errors.push("An error occurred while connecting to server")

          }).finally(() => {
      });
    },

    updateOrCreateHotspot() {
      this.loading = true;
      this.errors = [];
      if (this.name == null || this.name === '')
        this.errors.push("Name field is required.");
      if (this.make == null || this.make === '')
        this.errors.push("Make field is required.");
      if (this.mac_address == null || this.mac_address === '')
        this.errors.push("Mac address field is required.");
      if (this.serial_number == null || this.serial_number === '')
        this.errors.push("Serial number field is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      let params = {
        name: this.name,
        make: this.make,
        mac_address: this.mac_address,
        serial_number: this.serial_number,
        custom_splash_url: this.custom_splash_url,
        success_url: this.success_url,
        description: this.description,
        venue_id: this.venueId,
        lat: this.lat,
        lng: this.lng
      };

      let request = this.accessPointId == null ? this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/access_points', params) :
          this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/access_points/' + this.accessPointId, params)

      request.then((result) => {
        this.$root.$emit('alert_success', [result.data.data.message]);
        this.hotspot = result.data.data.access_point;
      }).catch((error) => {
        if (error.response != null && error.response.status === 422)
          this.errors = Utils.processError(error.response.data);
        else
          this.errors.push("An error occurred while connecting to server")
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>
<style scoped>
</style>
